import { ReactNode } from 'react'

import { useSetOnlineStatus } from 'src/hooks'

interface UserSessionOnlineWrapperProps {
  children: ReactNode
}

export const UserSessionOnlineWrapper = ({ children }: UserSessionOnlineWrapperProps) => {
  useSetOnlineStatus()

  return <>{children}</>
}
